const CryptoJS = require("crypto-js");

var key = CryptoJS.enc.Hex.parse("67797a715f777879785f6165735f3231"); //十六位十六进制数作为密钥
var iv = CryptoJS.enc.Hex.parse("714a7a344d4e68586152315462456256"); //十六位十六进制数作为密钥偏移量

//解密方法
function Decrypt(word) {
  // let a = "965d9c57016e60b185cde2e1f53e8e07";
  let text = CryptoJS.format.Hex.parse(word);

  let decryptStr = CryptoJS.AES.decrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let list = CryptoJS.enc.Utf8.stringify(decryptStr);
  // console.log();
  return list;
}

export default Decrypt;
